import { init_constants_environment } from '@shared/constants/_methods/init_constants_environment';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ConstantsLogger } from '@shared/logger/constants_logger';
import { delete_value_from_array } from '@shared/utils/utils_array';
import { CONSTANTS__environment_client } from './CONSTANTS__environment_client';

export function init_constants_client(): void {
  CONSTANTS__shared.IS_BROWSER = true;

  let environment_object = {};

  for (let key of Object.keys(import.meta.env)) {
    if (!key.startsWith('VITE_')) continue;

    (environment_object as any)[key] = import.meta.env[key];
  }

  init_constants_environment(CONSTANTS__environment_client, environment_object, 'VITE');

  delete_value_from_array(CONSTANTS__shared.SUPPORTED_LANGUAGES, ENUM__language_type.ENGLISH);

  CONSTANTS__shared.SUPPORTED_LANGUAGES.sort();

  //add eng as first
  CONSTANTS__shared.SUPPORTED_LANGUAGES.unshift(ENUM__language_type.ENGLISH);

  ConstantsLogger.ENABLE_LOG_SIZE = CONSTANTS__environment_client.VITE_DEVELOPMENT_LOG_SIZE_ENABLED_BOOLEAN;
}
